import React from 'react';
import { arrayOf, oneOf, string, shape } from 'prop-types';
import { Script } from 'nordic/script';

/* istanbul ignore next */
const ScriptTracks = ({ url, event_tracking, verification_resources, itemClassName, hydrate }) => {
  const [firstDelayedPrintUrl] = event_tracking?.delayed_print ?? [];
  const [firstViewUrl] = event_tracking?.view ?? [];
  const delayedPrint = firstDelayedPrintUrl ? firstDelayedPrintUrl.url : '';

  const isUnmountedRef = React.useRef(false);

  React.useEffect(() => {
    isUnmountedRef.current = false;

    const sendPrint = async (retries = 3, delay = 1000) => {
      if (isUnmountedRef.current) return;

      try {
        const response = await fetch(url, { method: 'GET' });

        if (!response.ok) {
          throw new Error(`Request failed - Status: ${response.status}, Print URL: ${url}`);
        }
      } catch (error) {
        if (!isUnmountedRef.current && retries > 0) {
          await new Promise((resolve) => setTimeout(resolve, delay));
          sendPrint(retries - 1, delay);
        }
      }
    };

    if (url) {
      sendPrint();
    }

    return () => {
      isUnmountedRef.current = true;
    };
  }, [url]);

  return (
    <>
      <div id="verification-resources" data-resources={JSON.stringify(verification_resources)} hidden />
      <Script>
        {`
          if (${hydrate === 'defer'}) {
            var firstViewUrl = ${JSON.stringify(firstViewUrl)};
            var delayedPrint = '${delayedPrint}';
            var dataElement = document.getElementById('verification-resources')
            var verificationResources = [];

            if (dataElement && dataElement.dataset.resources) {
              try {
                verificationResources = JSON.parse(dataElement.dataset.resources);
              } catch (error) {
                console.error('Error parsing JSON from data attribute "resources":', error);
              }
            }

            var carouselItemRef = document.querySelector('.${itemClassName}');
              
            function startViewabilitySession() {
              if (window.viewability && carouselItemRef && firstViewUrl?.url) {
                var session = window.viewability.addSession(verificationResources, delayedPrint);
                session.setMeliVaTrackUrl(firstViewUrl.url);
                session.start(carouselItemRef);
                window.viewability.setTag(verificationResources, carouselItemRef);
              }
            };

            document.getElementById('viewability-script').addEventListener('load', function() {
              if (window.viewability) {
                startViewabilitySession();
              }
            });
          }
        `}
      </Script>
    </>
  );
};

ScriptTracks.propTypes = {
  url: string,
  event_tracking: shape({
    print: arrayOf(
      shape({
        url: string,
      }),
    ),
    view: arrayOf(
      shape({
        url: string,
      }),
    ),
  }),
  verification_resources: arrayOf(shape({})),
  itemClassName: string,
  hydrate: oneOf(['defer', 'now']),
};

export default ScriptTracks;
